














import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { User } from '@/models/user/user.model';
import { DashboardPaths, BusConstants } from '@/core/constants';
import bus from '@/core/bus';

@Component
export default class ProfileMenu extends Vue {
	@Prop() isLoggedIn!: boolean;

	get User(): User | null {
	    return UserModule.user;
	}

	ToggleMenu() {
	    if (!this.User) {
	        UserModule.Logout();
	        return;
	    }
	    bus.emit(BusConstants.ShowProfileMenu);
	}

	Login() {
	    bus.emit(BusConstants.LoginRequired, DashboardPaths.Home);
	}
}
